// extracted by mini-css-extract-plugin
export default {"shadow":"k1QUaQ12tgY2LEtt_QgQ","stickable":"fxuGQ6oRNXDBIpCKgEaw","placeHolderShimmer":"RLYyybHimEYyRDBWq70e"};